import ConfirmExtend from "pages/CompensationExtend/components/ConfirmExtend/ConfirmExtend";

export default ConfirmExtend